import {
  Box,
  Typography,
  IconButton,
  Button,
  Grid,
  Link,
  Divider,
} from "@mui/material";
import { motion } from "framer-motion";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Instagram } from "@mui/icons-material";
import { FacebookIcon } from "lucide-react";
import X from "@mui/icons-material/X";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const MotionTypography = motion(Typography);

const Footer = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        background: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          bgcolor: "rgba(229, 224, 224, 0.51)",
          backdropFilter: "blur(15px)",
          color: "#333",
          py: 4,
          borderRadius: "32px 32px 0 0", // Rounded top corners to match design
          boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            px: 4,
            mb: 2,
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: { xs: "center", sm: "flex-start" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <Box>
                <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                  Aastha computers
                </Typography>
                <Typography>Learn | Masters | Grow</Typography>
              </Box>
              <Box>
                <Box sx={{ display: "flex", gap: "0.8rem" }}>
                  <IconButton
                    size="medium"
                    color="black !important"
                    href="https://www.facebook.com/aastha.computers.10"
                    target="_blank"
                    sx={{ color: "black !important" }}
                  >
                    <FacebookIcon />
                  </IconButton>
                  <IconButton
                    size="medium"
                    color="black"
                    href="wa.me/9928004669"
                    target="_blank"
                    sx={{ color: "black !important" }}
                  >
                    <FaWhatsapp />
                  </IconButton>
                  <IconButton
                    size="medium"
                    color="black"
                    href="https://www.instagram.com/aasthacomputers_/"
                    target="_blank"
                    sx={{ color: "black !important" }}
                  >
                    <Instagram />
                  </IconButton>
                  <IconButton
                    size="medium"
                    color="black"
                    href="https://www.linkedin.com/company/aastha-computers/"
                    target="_blank"
                    sx={{ color: "black !important" }}
                  >
                    <LinkedInIcon />
                  </IconButton>
                </Box>
              </Box>
              <Box>
                <Typography>
                  <Button
                    onClick={() => navigate("/courses")}
                    variant="outlined"
                    sx={{
                      color: "#333",
                      fontWeight: "bold",
                      border: "1px solid black",
                      borderRadius: "22px",
                    }}
                  >
                    Explore Course
                  </Button>
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={3}>
              {/* Sitemap Section */}
              <Grid item xs={4} sm={4}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                  Sitemap
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.8rem",
                  }}
                >
                  <Link href="/" color="inherit" underline="hover">
                    Home
                  </Link>
                  <Link href="/courses" color="inherit" underline="hover">
                    Courses
                  </Link>
                  <Link href="/blogs" color="inherit" underline="hover">
                    Blogs
                  </Link>
                  <Link href="/about" color="inherit" underline="hover">
                    About
                  </Link>
                  <Link href="/contact" color="inherit" underline="hover">
                    Contact
                  </Link>
                </Box>
              </Grid>

              {/* Others Section */}
              <Grid item xs={4} sm={4}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                  Others
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.8rem",
                  }}
                >
                  <Link href="/gallery" color="inherit" underline="hover">
                    Gallery
                  </Link>
                  <Link href="/events" color="inherit" underline="hover">
                    Events
                  </Link>
                  <Link href="/careers" color="inherit" underline="hover">
                    Careers
                  </Link>
                  <Link
                    href="/terms-and-conditions"
                    color="inherit"
                    underline="hover"
                  >
                    Terms & Conditions
                  </Link>
                  <Link
                    href="/privacy-policy"
                    color="inherit"
                    underline="hover"
                  >
                    Privacy Policy
                  </Link>
                </Box>
              </Grid>

              {/* Courses Section */}
              <Grid item xs={4} sm={4}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                  Trending Courses
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.8rem",
                  }}
                >
                  <Link href="/courses" color="inherit" underline="hover">
                    Web Development
                  </Link>
                  <Link href="/courses" color="inherit" underline="hover">
                    Tally Course
                  </Link>
                  <Link href="/courses/" color="inherit" underline="hover">
                    Digital Marketing
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider />

        {/* Copyright */}
        <Box
          sx={{
            textAlign: "center",
            mt: 2,
            // pt: 2,
            // borderTop: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
              gap: "0.8rem",
            }}
          >
            <IconButton
              size="medium"
              color="black"
              href="https://www.facebook.com/aastha.computers.10"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="wa.me/9928004669"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FaWhatsapp />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.instagram.com/aastha_computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FaInstagram />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.linkedin.com/company/aastha-computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FaLinkedin />
            </IconButton>
          </Box>
          <Typography variant="body2">
            Developed and Maintained with ❤️ by{" "}
            <strong>
              <Link color="#333" href="https://www.sitinovations.in">
                SITInovations
              </Link>
            </strong>
          </Typography>
          <Typography variant="body2">
            Copyright <strong>Aastha computers</strong> © 2024
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
